
(() => {
  const root = document;

  function initTabs(scope = root) {
    scope.querySelectorAll('[data-tw-pdp-tabs]').forEach((tabs) => {
      if (tabs.dataset.initialized === 'true') return;
      tabs.dataset.initialized = 'true';
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];
      const activate = (button, focus = false) => {
        buttons.forEach((item) => item.setAttribute('aria-selected', item === button ? 'true' : 'false'));
        panels.forEach((panel) => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
        if (focus) button.focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          activate(buttons[next], true);
        });
      });
    });
  }

  function initScrollers(scope = root) {
    scope.querySelectorAll('[data-tw-scroll-container]').forEach((container) => {
      if (container.dataset.scrollInitialized === 'true') return;
      container.dataset.scrollInitialized = 'true';
      const track = container.querySelector('[data-tw-scroll-track]');
      if (!track) return;
      container.querySelectorAll('[data-tw-scroll-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.twScrollDirection === 'next' ? 1 : -1;
          track.scrollBy({ left: direction * Math.max(220, track.clientWidth * .8), behavior: 'smooth' });
        });
      });
    });
  }

  function initReviewLinks(scope = root) {
    scope.querySelectorAll('[data-cro-review-link]').forEach((link) => {
      if (link.dataset.reviewInitialized === 'true') return;
      link.dataset.reviewInitialized = 'true';
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init(scope = root) {
    initTabs(scope);
    initScrollers(scope);
    initReviewLinks(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('cart:update', () => requestAnimationFrame(() => init()));
  document.addEventListener('cart:refresh', () => requestAnimationFrame(() => init()));
})();
